<template>
  <div>
    <div class="input-wrapper" :style="computedStyle">
      <div class="pc-input-icon"></div>
      <input
        class="tx-input"
        :type="type"
        :value="modelValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :maxlength="maxlength"
        :min="min"
        :max="max"
        @input="handleInput"
        @change="handleChange"
        @focus="handleFocus"
        @blur="handleBlur"
        @keydown="handleKeydown"
        @keyup="handleKeyup"
        @keypress="handleKeypress"
        @keyup.enter="handleEnter"
      />
    </div>
  </div>
</template>
<script setup>
import config from '@img/config.json';
import px2vw from '@/utils/px2vw_v2';
const { support_image, is_mobile } = inject('GlobalStore');

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  type: {
    type: String,
    default: 'text',
  },
  placeholder: {
    type: String,
    default: '请输入角色名称',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
  maxlength: {
    type: [String, Number],
    default: null,
  },
  min: {
    type: [String, Number],
    default: null,
  },
  src: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: false,
  },
});

// Emits 定义
const emit = defineEmits([
  'update:modelValue',
  'input',
  'change',
  'focus',
  'enter',
  'blur',
  'clear',
  'keydown',
  'keyup',
  'keypress',
]);

const bg = computed(() => {
  let src = config[props.src].src;
  return `${src}.${support_image.value}`;
});

const computedStyle = computed(() => {
  const size = config[props.src];

  return {
    backgroundImage: `url(${bg.value})`,
    width: px2vw(size.width, is_mobile.value),
    height: px2vw(size.height, is_mobile.value),
  };
});

// 事件处理函数
const handleInput = (event) => {
  const value = event.target.value;
  emit('update:modelValue', value);
  emit('input', value, event);
};

const handleChange = (event) => {
  emit('change', event.target.value, event);
};

const handleFocus = (event) => {
  // isFocused.value = true;
  emit('focus', event);
};

const handleBlur = (event) => {
  // isFocused.value = false;
  emit('blur', event);
};

const handleClear = () => {
  emit('update:modelValue', '');
  emit('clear');
  emit('input', '');

  // 聚焦到输入框
  nextTick(() => {
    if (inputRef.value) {
      inputRef.value.focus();
    }
  });
};

const handleKeydown = (event) => {
  emit('keydown', event);
};

const handleKeyup = (event) => {
  emit('keyup', event);
};

const handleKeypress = (event) => {
  emit('keypress', event);
};

const handleEnter = (event) => {
  emit('enter', event);
}
</script>
<style scoped>
.tx-input {
  border: 1px solid transparent;
  background-color: transparent;
  text-align: left;
  height: 22px;
  font-size: 20px;
}

.pc-input-icon {
  min-width: 100px;
  max-width: 100px;
}
.input-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
  color: rgba(0, 0, 0, 0.88);
  font-size: 14px;
}
</style>
